import React from 'react'

import styles from './Input.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default React.forwardRef((props, ref) => {
    return <input {...props} className={classes('default', props?.className)} ref={ref} />
})
